import { Component } from '@angular/core';
import { LocalUtils } from './restricted/restricted.utils';
import { HeaderService } from './components/app-header/app.header.service';
import { AppConfig } from './app.config';

@Component({
  selector: 'body',
  template: '<router-outlet></router-outlet><block-ui></block-ui><toaster-container [toasterconfig]="toasterconfig"></toaster-container>'
})

export class AppComponent {
  constructor(private headerService: HeaderService,
    private appConfig: AppConfig) {

    this.headerService.getApiUrl().subscribe((r: any) => {
      this.appConfig.apiUrl = r.apiurl;
      this.appConfig.adminurl = r.adminurl;
    });

  }
}

// BODY options, add following classes to body to change options
// // Header options
// 1. '.header-fixed'					- Fixed Header
// // Brand options
// 1. '.brand-minimized'       - Minimized brand (Only symbol)
// // Sidebar options
// 1. '.sidebar-fixed'					- Fixed Sidebar
// 2. '.sidebar-hidden'				- Hidden Sidebar
// 3. '.sidebar-off-canvas'		- Off Canvas Sidebar
// 4. '.sidebar-minimized'			- Minimized Sidebar (Only icons)
// 5. '.sidebar-compact'			  - Compact Sidebar
// // Aside options
// 1. '.aside-menu-fixed'			- Fixed Aside Menu
// 2. '.aside-menu-hidden'			- Hidden Aside Menu
// 3. '.aside-menu-off-canvas'	- Off Canvas Aside Menu
// // Breadcrumb options
// 1. '.breadcrumb-fixed'			- Fixed Breadcrumb
// // Footer options
// 1. '.footer-fixed'					- Fixed footer



// WEBPACK FOOTER //
// ./src/app/app.component.ts